module.exports = __webpack_public_path__ + "static/media/Tipo_presencial.edb23222.png";